import '@Libs/pStrength.jquery.js';
import '@Styles/auth-form.scss';
import enums from './Enums';

declare const model: {
    enforcePasswordPolicy: boolean;
    loggingFailed: boolean;
    applicationType: enums.ApplicationType;
    changePasswordMode: boolean;
    changePassword: boolean;
    passwordExpired: boolean;
};
$(() => {
    const localize = (ctrl: JQuery, label: string, placeholder: string) => {
        ctrl.attr('placeholder', placeholder);
        $(`label[for=${ctrl.attr('id')}]`).text(label);
    };

    let passwordStrengthMsg = '';
    const resources = strings.loginControl;
    const $userName = $('#_userName');
    const $password = $('#_password');
    const $newPassword = $('#_newPassword');
    const $confirmPassword = $('#_confirmPassword');
    const $infoMessage = $('#infoMessage');
    const $errorRow = $('#errorRow');
    const $message = $('.message');
    const newPasswordInput = $newPassword.get(0) as HTMLInputElement;
    const confirmPasswordInput = $confirmPassword.get(0) as HTMLInputElement;
    $('.logo>img').attr('alt', resources.logo);

    localize($userName, resources.usernameTitle, resources.username);
    localize($password, resources.passwordTitle, resources.passwordTitle);
    localize($newPassword, resources.newPasswordTitle, resources.newPasswordTitle);
    localize($confirmPassword, resources.confirmPasswordTitle, resources.confirmPassword);

    $userName.trigger('focus');

    $('.button.accept').text(model.changePasswordMode ? resources.apply : resources.loginBtn);

    if (!$message.text()) {
        if (model.loggingFailed) {
            const appName = enums.applicationType.getName(model.applicationType);
            const message = strings.errorControl.unableToLogIn.format(appName);
            $message.text(message);
        } else if (model.passwordExpired) {
            $message.text(resources.passwordExpired);
        }
    }

    $('.auth-form-panel').on('submit', () => {
        $infoMessage.text(strings.loginControl.processing);
        $errorRow.remove();
    });

    function checkEquality(): void {
        if ($newPassword.length) {
            if ($newPassword.val() === $password.val()) {
                newPasswordInput.setCustomValidity(strings.loginControl.passwordMustDiffer);
            } else {
                newPasswordInput.setCustomValidity(passwordStrengthMsg);
            }
        }

        if ($confirmPassword.length) {
            if ($newPassword.val() !== $confirmPassword.val()) {
                confirmPasswordInput.setCustomValidity(strings.loginControl.confirmMustMatch);
            } else {
                confirmPasswordInput.setCustomValidity('');
            }
        }
    }

    $password.on('keyup', checkEquality);
    $newPassword.on('keyup', checkEquality);
    $confirmPassword.on('keyup', checkEquality);

    if (model.enforcePasswordPolicy !== false) {
        $newPassword.pStrength({
            changeBackground: false,
            onPasswordStrengthChanged: passwordStrength => {
                if ($newPassword.val()) {
                    $.fn.pStrength('changeBackground', $newPassword, passwordStrength);
                } else {
                    $.fn.pStrength('resetStyle', $newPassword);
                }
                passwordStrengthMsg = strings.loginControl.pStrength;
                newPasswordInput.setCustomValidity(passwordStrengthMsg);
            },
            onValidatePassword: () => {
                passwordStrengthMsg = '';
                newPasswordInput.setCustomValidity(passwordStrengthMsg);
            }
        });
    }
});
